//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatDate, formatTime, convertConfiguredTime, convertIntervalToDeltaDH } from '../../../../components/helpers.js'
import { axiosPost } from '../../../../axios/axios.js'
import Table from '../../../../components/Table/Table.vue'

import VehicleProvisionRequestBrigadesEdit from './VehicleProvisionBrigadesEdit.vue'

export default {
  components: {
    VehicleProvisionRequestBrigadesEdit,
    Table
  },
  props: {
    brigades: {
      type: Array,
      default: () => {
        return []
      }
    },
    brigadesProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    interval: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rules: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: function () {
    return {
      openedEdit: false,
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'brigadeGUIName',
          label: 'Название бригады',
          align: 'left',
          field: 'brigadeGUIName',
          sortable: true
        },
        {
          name: 'workDate',
          label: 'Дата рабочей смены',
          align: 'left',
          field: 'workDate',
          format: formatDate,
          sortable: true
        },
        {
          name: 'workShift',
          label: 'Смена',
          align: 'left',
          field: 'workShift',
          format: workShift => workShift.name,
          sortable: true
        },
        {
          name: 'endTime',
          label: 'Окончание смены',
          align: 'left',
          field: 'workShift',
          format: workShift => {
            let timeText = this.convertTime(workShift.endTime)
            const currentTime = new Date().getTime()
            if (workShift.endTime > currentTime) {
              timeText += ' (осталось ' + convertIntervalToDeltaDH(workShift.endTime, currentTime) + ')'
            }
            return timeText
          },
          sortable: true
        },
        {
          name: 'workAreas',
          label: 'Направление работ',
          align: 'left',
          field: 'workAreas',
          format: workAreas => workAreas != null && workAreas.length ? workAreas.map(wA => wA.name).join(', ') : '',
          sortable: true
        },
        {
          name: 'assigned',
          label: 'Текущее назначение',
          align: 'left',
          field: 'assigned',
          sortable: true
        },
        {
          name: 'nextAssigned',
          label: 'Ожидается назначение',
          align: 'left',
          field: 'nextAssigned',
          sortable: true
        },
        {
          name: 'time',
          label: 'Время внесения бригады в заявку',
          align: 'left',
          field: 'time',
          sortable: true,
          format: formatTime
        },
        {
          name: 'fio',
          label: 'Автор изменения (внесения бригады в заявку)',
          align: 'left',
          field: 'fio',
          sortable: true
        }
      ]
    }
  },
  computed: {
    filteredBrigades: function () {
      return this.brigades.filter(b => !b.removed)
    },
    accessAdd: function () {
      return this.brigadesProperties.accessProps && this.brigadesProperties.accessProps.add
    },
    accessAssign: function () {
      return this.brigadesProperties.accessProps && this.brigadesProperties.accessProps.assign
    },
    accessAssignNext: function () {
      return this.brigadesProperties.accessProps && this.brigadesProperties.accessProps.assignNext
    }
  },
  methods: {
    convertTime: function (ms) {
      return convertConfiguredTime(ms, { year: false, month: true, date: true, hour: true, min: true, sec: false })
    },
    validate: function () {
      if (this.brigades.length !== 0 && this.interval.start && this.interval.end) {
        const formData = new FormData()
        formData.set('fromTime', this.interval.start)
        formData.set('toTime', this.interval.end)
        formData.set('brigades', JSON.stringify(this.brigades.map(b => {
          return {
            id: b.brigadeId,
            workDate: b.workDate,
            workShift: b.workShift.key
          }
        })))

        return axiosPost({
          url: '/service/delta/vehicleProvision/validateBrigadesIntervals',
          data: formData,
          onSuccess: (response) => {
            const resultBrigades = response.data.result
            this.brigades.forEach(b => {
              const resultBrigade = resultBrigades.find(resB => resB.id === b.brigadeId && resB.workShift === b.workShift.key && resB.workDate === b.workDate)
              if (resultBrigade) {
                if (resultBrigade.status !== 'valid') {
                  this.$set(b, '_notValid', true)
                } else {
                  this.$set(b, '_notValid', false)
                }
              }
            })
          },
          onFailure: 'Ошибка получения валидации бригад'
        }).finally(() => {
          if (this.$refs.field) {
            return this.$refs.field.validate()
          }
        })
      } else {
        if (this.$refs.field) {
          return this.$refs.field.validate()
        }
      }
    },
    onAdd: function () {
      this.openedEdit = true
    },
    onDelete: function (brigade) {
      const index = this.brigades.findIndex(b => b.id === brigade.id)
      if (index !== -1) {
        this.$set(this.brigades[index], 'removed', true)
      }
    },
    onChangeNextAssigned: function (brigade) {
      brigade.nextAssigned = !brigade.nextAssigned
      this.$set(brigade, 'edited', true)

      const nextAssignedBrigade = this.brigades.find(b => {
        return b.nextAssigned && b.brigadeId !== brigade.brigadeId
      })
      if (nextAssignedBrigade) {
        nextAssignedBrigade.nextAssigned = false
        this.$set(nextAssignedBrigade, 'edited', true)
      }
    },
    onChangeAssigned: function (brigade) {
      brigade.assigned = !brigade.assigned

      if (brigade.assigned) {
        brigade.nextAssigned = false
      }

      this.$set(brigade, 'edited', true)

      const assignedBrigade = this.brigades.find(b => b.assigned && b.brigadeId !== brigade.brigadeId)
      if (assignedBrigade) {
        assignedBrigade.assigned = false
        this.$set(assignedBrigade, 'edited', true)
      }
    },
    onSaveEdit: function (brigades) {
      const assign = brigades.length === 1 && (this.brigades.length === 0 || this.brigades.find(brigade => !brigade.removed) == null)

      brigades.forEach((brigade) => {
        this.$set(brigade, 'added', true)
        this.$set(brigade, 'deletable', true)
        if (assign) {
          this.$set(brigade, 'assigned', true)
        }
        this.brigades.push(brigade)
      })
      this.onCloseEdit()
    },
    onCloseEdit: function () {
      this.openedEdit = false
    },
    getTrClass: function (row) {
      if (row._notValid) {
        return 'd-tr--red'
      }
    },
    getTdStyle: function (col, row) {
      if (col.name === 'endTime' && row.workShift.endTime) {
        const currentTime = new Date().getTime()

        if ((row.assigned || row.nextAssigned) && row.workShift.endTime > currentTime && (row.workShift.endTime - currentTime) < 2 * 60 * 60 * 1000) {
          return this.getColoredTdStyle('orange', 'white')
        }
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 1000) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}

